import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { MatchingProductsState, SolutionComponent } from '../Types/MatchingProducts.ts';
import { resetFitAssistant } from '../Thunks/Reset.ts';
import { GetProductsQuery } from '../Types/FitAssistantGraphQLTypes.ts';

const initialState: MatchingProductsState = {
  matchingProducts: null,
  solutionComponents: null,
  productPageMatch: false,
  solutionPriceContainer: null,
  addToCartButton: null,
  selectedSolutionIndex: 0,
};

export const MatchingProductsSlice = createSlice({
  name: 'matchingProducts',
  initialState,
  reducers: {
    addMatchingProducts: (state, { payload }: PayloadAction<GetProductsQuery>) => {
      state.matchingProducts = payload?.getCarSelectorProducts?.carSelectorProductsResponse?.MatchingProducts;
      state.solutionComponents = payload?.getCarSelectorProducts?.carSelectorProductsResponse?.SolutionComponents;
      state.productPageMatch = payload?.getCarSelectorProducts?.carSelectorProductsResponse?.ProductPageMatch;
      state.solutionPriceContainer =
        payload?.getCarSelectorProducts?.carSelectorProductsResponse?.SolutionPriceContainer;
      state.addToCartButton = payload?.getCarSelectorProducts?.carSelectorProductsResponse?.AddToCartButton;
      state.selectedSolutionIndex = 0;
    },
    setSelectedSolutionIndex: (state, { payload }: PayloadAction<number>) => {
      state.selectedSolutionIndex = payload;
    },
    addSolutionComponents: (state, { payload }: PayloadAction<SolutionComponent[]>) => {
      state.solutionComponents = payload;
    },
    clearMatchingProducts: (state) => {
      state.matchingProducts = null;
      state.solutionComponents = null;
      state.productPageMatch = false;
      state.solutionPriceContainer = null;
      state.addToCartButton = null;
      state.selectedSolutionIndex = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetFitAssistant.pending, (state) => {
      MatchingProductsSlice.caseReducers.clearMatchingProducts(state);
    });
  },
});

export const { addMatchingProducts, addSolutionComponents, clearMatchingProducts, setSelectedSolutionIndex } =
  MatchingProductsSlice.actions;

export default MatchingProductsSlice.reducer;
